<template>
  <LoginSingleLayout wide>
    <Alert :i18nData="asyncError" />
    <CodeInputForm
      :subtitle="subtitleText"
      :heading="$t('pages.recoverPin.heading')"
      :hint="$t('pages.recoverPin.hint')"
      :submit-label="$t('pages.recoverPin.buttonOk')"
      :loading="loading"
      @submit="onSubmit"
      @input="clearError"
    >
      <template #messages>
        <div v-if="showSMSPinAbused"
          id="sms-pin-abused"
          class="my-4 p-2 message-box alert alert-danger"
          v-html="$t('pages.recoverPin.smsPinAbused', { supportEmail: SUPPORT_EMAIL_ADDR })"
        />
        <div v-else-if="showSMSPinWarning"
          id="sms-pin-warning"
          class="my-4 p-2 message-box alert alert-warning"
          v-html="$t('pages.recoverPin.smsPinWarning', { supportEmail: SUPPORT_EMAIL_ADDR })"
        />
      </template>
      <template #secondary>
        <router-link :to="'/recover'">
          {{ $t('pages.recoverPin.resendText') }}
        </router-link>
      </template>
    </CodeInputForm>
  </LoginSingleLayout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { E_VALIDATION, SUPPORT_EMAIL_ADDR } from '@/constants'
import LoginSingleLayout from '@/components/LoginSingleLayout.vue'
import CodeInputForm from '@/components/CodeInputForm.vue'

export default {
  name: 'RecoverPin',
  components: {
    LoginSingleLayout,
    CodeInputForm
  },
  data () {
    return {
      loading: false,
      asyncError: null
    }
  },
  computed: {
    ...mapState({
      type: state => state.recover.type,
      value: state => state.recover.value,
      showSMSPinAbused: 'smsPinAbused'
    }),
    ...mapGetters(['showSMSPinWarning']),
    subtitleText () {
      if (this.type === 'phone') {
        return this.$t('pages.recoverPin.subtitlePhone', { value: `+${this.value}` })
      } else {
        return this.$t('pages.recoverPin.subtitleEmail', { value: this.value })
      }
    }
  },
  methods: {
    ...mapActions(['checkValidation']),
    clearError () {
      this.asyncError = null
    },
    onSubmit (pin) {
      this.loading = true
      this.asyncError = null
      return this.checkValidation(pin).then(() => {
        this.$router.push({ name: 'recoverPass', query: this.$route.query })
      }).catch(err => {
        if (err.id === E_VALIDATION) {
          this.asyncError = { key: 'pages.recoverPin.error' }
        } else {
          throw err
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  created () {
    this.SUPPORT_EMAIL_ADDR = SUPPORT_EMAIL_ADDR
  }
}
</script>
